<app-navigation></app-navigation>
<app-header></app-header>
<router-outlet></router-outlet>
<app-about></app-about>
<app-contact></app-contact>

<app-footer></app-footer>
<app-chat-widget></app-chat-widget>


